// ABOUTME: Provides literal pre-registration template variables to translated interface copy.
// ABOUTME: Keeps i18next from consuming variable examples in recruiter guidance.
export const whatsappPreRegistrationTemplatePlaceholderValues = {
    companyName: "{{companyName}}",
    storeName: "{{storeName}}"
};
